import { Icon } from './types';

export const ArrowUp = ({ svgProps, pathProps }: Icon) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    viewBox="0 0 24 24"
    fill="none"
    data-testid="arrow-up"
    {...svgProps}
  >
    <path
      d="M7.41 15.41 12 10.83l4.59 4.58L18 14l-6-6-6 6 1.41 1.41z"
      fill="currentColor"
      {...pathProps}
    />
  </svg>
);
